import React from "react";
import { useStoreState } from "../hooks/ep";
import {
  useEnsureDeadFlopptionsData,
  useEnsureDeadOppsData,
} from "../helpers/useEnsureData";
import AgTable from "./AgTable";
import "styled-components/macro";
import { ReportActionModalWrapper } from "./reporting-actions/modal-or-drawer";
import { useColDefs } from "./dead-opps-table-coldefs";
import { Spinner } from "@blueprintjs/core";

function TableInner() {
  const rowData = useStoreState((s) => s.dead_opps.initialData);
  rowData.forEach((row) => {
    row.id = ["TripId", "leg_i"].map((k) => row[k]).join(".");
  });

  const colDefs = useColDefs("dead_opps");

  return (
    <>
      <AgTable rowData={rowData} columnDefs={colDefs} tableName="dead_opps" />
      <ReportActionModalWrapper />
    </>
  );
}

export function DeadOppsTable() {
  const loadingOpps = useEnsureDeadOppsData();
  const loadingFlopps = useEnsureDeadFlopptionsData();
  const loading = loadingOpps || loadingFlopps;
  return loading ? <Spinner /> : <TableInner />;
}
